import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { TaskProvider } from "./index";
//import { DEFAULT_TASK_STATE } from './lib/constants';
import { getTask as getTaskState } from "../../shared/taskState";
import { BRAND_VERIFIED_WORKFLOW_TYPE_ID } from "../../components/shipment-editor/lib/constants";

export const taskTypeMessageKeyMap = {
    "measuring.standard": "measuring",
    "photography.standard": "photography",
    "scheduling.default": "scheduling",
    "coding.standard": "coding",
    "codingqa.standard": "codingQA",
    "imageediting.standard": "imageEditing",
    "imageeditingqa.standard": "imageEditingQA",
    "finalqa.standard": "finalQA",
};

const getTask = (taskId, isDuplicateStage) => {
    return getTaskState(taskId, isDuplicateStage).then((task) => {
        if (!task) {
            return;
        }

        return {
            ...task,
            hasIMDropboxContent:
                task.hasDigitalContent && task.locationInfo.companyName === "ItemMaster" && task.locationInfo.location !== "BYOC_Digital",
            requiresEcom: !task.context.isSampleUpc,
            upc: task.context.upc,
            fullUpc: task.context.productModifier ? `${task.context.upc}-${task.context.productModifier}` : task.context.upc,
            hasPremiumEditing: task.context.hasPremiumEditing,
            isSampleUpc: task.context.isSampleUpc,
            shipmentKey: task.context.shipmentKey,
            shipmentProductKey: task.context.shipmentProductKey,
            taskContextKey: task.context.key,
            taskMessage: task.messages ? task.messages[taskTypeMessageKeyMap[task.taskType]] : null,
            sourcePage: task.taskType ? task.taskType.split(".")[0] : "",
            isBrandVerified: task.context.workflowTypeId === BRAND_VERIFIED_WORKFLOW_TYPE_ID,
        };
    });
};

const Task = (props) => {
    const { id } = useParams();
    const [task, setTask] = useState(null);
    const isDuplicateStage = props.settings && props.settings.isDuplicateStage;

    useEffect(() => {
        async function fetchData() {
            const response = await getTask(id, isDuplicateStage);

            if (!response) {
                return;
            }

            setTask(response);
        }

        fetchData();
    }, []);

    // TODO: Provider always has to return something, fix this because removing this statement is breaking Coding page
    if (!task) {
        return null;
    }

    return <TaskProvider value={{ task }}>{props.children}</TaskProvider>;
};

export default Task;
